import React, { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { addMinutes, getDateFromOffset } from '../../../helpers/dates';
import { useHistory } from 'react-router-dom';
import { convertTime12to24 } from '../../../helpers/dates';
import { useTranslation } from 'react-i18next';
import { closestIndexTo, format } from 'date-fns';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import Button from '../../../components/Common/Button/Button';
import styles from '../reservation.module.css';
import '../../../css/product-list.css';
import SuccessScreen from '../../Common/SuccessScreen';
import { WelletContext } from '../../../context/WelletContext';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import CustomerSpecialRequest from '../../../components/ReservationCheck/CustomerSpecialRequest/CustomerSpecialRequest';
import BookSelectorModify from '../../../components/BookSelector/BookSelectorModify';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';

const ModifyReservation = () => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const history = useHistory();
  const reservationInfo = history.location.state;
  const [restaurantId, setRestaurantId] = useState(reservationInfo?.showId);
  const [loading, setLoading] = useState(true);
  const [today, setToday] = useState(null);
  const [compareToday, setCompareToday] = useState(null);
  const [selectedPax, setSelectedPax] = useState(reservationInfo?.paxs);
  const [selectedDate, setSelectedDate] = useState(
    format(new Date(reservationInfo?.reservationDate), 'yyyy-MM-dd'),
  );
  const reservation = useSelector((state) => state.reservation);

  const [selectedPerformance, setSelectedPerformance] = useState(null);
  const [intervals, setIntervals] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [modifyingReservation, setModifyingReservation] = useState(false);
  const [response, setResponse] = useState(null);
  const reservationType = 'RESTAURANT';
  const [selectedDateBook, setSelectedDateBook] = useState(null);
  useEffect(() => {
    if (!reservationInfo && !modifyingReservation) {
      history.goBack();
    }
  }, [reservationInfo]);
  const swiperTimeRef = useRef(null);
  const [loadingIntervals, setLoadingIntervals] = useState(true);

  const getSchedule = async (date, paxs = null, hour = null) => {
    setLoadingIntervals(true);
    try {
      let params = `showId=${restaurantId}&date=${date}&reservationType=${reservationType}&details=true`;
      if (hour) {
        params += `&hour=${hour}`;
      }
      if (paxs) {
        params += `&paxs=${paxs}`;
      }

      const result = await welletContext.apis.tickets.get(`/shows/GetSchedule?${params}`);

      if (result.data.schedules.length === 0) {
        setIntervals([]);
      }

      const formattedTimes = result.data?.schedules?.map((time) => {
        const time24 = new Date(date + 'T' + convertTime12to24(time.timeStart));

        if (time.timeMinutesStart >= 0 && time.timeMinutesStart <= 360)
          time24.setDate(time24.getDate() + 1);

        return { time24, soldOut: time.isSoldOut, availabilityRefId: time.availabilityRefId };
      });
      formattedTimes.sort();

      const allIntervals = formattedTimes.map(({ time24, soldOut, availabilityRefId }) => ({
        time: time24,
        soldOut,
        availabilityRefId,
      }));

      setIntervals(allIntervals.filter((x) => !x.soldOut));
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingIntervals(false);
    }
  };

  const setClosedTime = (date, intervals) => {
    if (swiperTimeRef.current && swiperTimeRef.current.swiper) {
      const index = closestIndexTo(date, intervals);
      swiperTimeRef.current.swiper.slideTo(index);
    }
  };

  useEffect(() => {
    if (intervals) {
      const referenceDate = new Date(reservation.date + 'T' + reservation.performance);

      setClosedTime(
        referenceDate,
        intervals.map((item) => item.time),
      );
    }
  }, [intervals]);

  const onBookSelectorChange = (e) => {
    setSelectedDateBook(new Date(e.date + 'T' + e.time));
    setSelectedDate(e.date);
    setSelectedPax(e.pax);
    getSchedule(e.date, e.pax, e.time);
    setSelectedPerformance(null);
  };

  const [timeSelected, setTimeSelected] = useState(null);
  const onTimeClick = (time) => {
    setTimeSelected(time);
    setSelectedPerformance(time);
  };

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: restaurantId,
        },
      });

      const todayDate = new Date(getDateFromOffset(result.data.utcOffset));
      const minutes = todayDate.getMinutes();
      todayDate.setMinutes(minutes === 0 ? minutes : minutes + (15 - (minutes % 15)), 0, 0);

      setToday(todayDate);
      const yesterdayDate = new Date(todayDate);
      yesterdayDate.setDate(yesterdayDate.getDate() - 1);

      setCompareToday(addMinutes(todayDate, 20));

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const reservationDate = reservationInfo?.reservationDate
      ? new Date(reservationInfo.reservationDate)
      : new Date();

    setSelectedDateBook(reservationDate);
    getShow();
  }, []);

  const renderBookSelector = () => {
    return (
      <div className='mt-1 pt-3 mb-3'>
        <div className='book-selector-container'>
          <BookSelectorModify
            selectedDateBook={selectedDateBook}
            today={today}
            lang={language}
            onChange={onBookSelectorChange}
            paxs={reservationInfo.paxs}
          />

          <div className='mt-3' style={{ height: '40px' }}>
            <Swiper
              spaceBetween={10}
              slidesPerView={'auto'}
              centeredSlides={true}
              centeredSlidesBounds={true}
              ref={swiperTimeRef}
            >
              {loadingIntervals
                ? [...Array(5)].map((_, i) => (
                    <SwiperSlide key={i}>
                      <div
                        style={{
                          backgroundColor: '#191919',
                          borderRadius: '5px',
                          height: '38px',
                          width: '78px',
                        }}
                      ></div>
                    </SwiperSlide>
                  ))
                : intervals.map((item, i) => (
                    <SwiperSlide key={i}>
                      <button
                        className={`button-filter font-small ${
                          timeSelected === format(item.time, 'HH:mm') ? 'time-selected' : ''
                        } `}
                        onClick={() =>
                          onTimeClick(format(item.time, 'HH:mm'), item.availabilityRefId)
                        }
                      >
                        {format(item.time, 'h:mm aaa')}
                      </button>
                    </SwiperSlide>
                  ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  const hours = selectedDateBook?.getHours().toString().padStart(2, '0');
  const minutes = selectedDateBook?.getMinutes().toString().padStart(2, '0');
  const time = `${hours}:${minutes}`;

  useEffect(() => {
    if (today !== null);
    const formattedDate = format(new Date(selectedDateBook), 'yyyy-MM-dd');
    getSchedule(formattedDate, reservationInfo.paxs, time);
  }, [selectedDateBook]);

  const datePerformance = selectedDate + ' ' + selectedPerformance;
  const [specialRequest, setSpecialRequest] = useState(reservationInfo.comments || '');

  const handleSpecialRequestChange = (e) => {
    setSpecialRequest(e.target.value);
  };

  const handleModify = async () => {
    setModifyingReservation(true);
    try {
      const response = await welletContext.apis.tickets.put('/reservation/ModifyReservation', {
        showId: restaurantId,
        paxs: selectedPax,
        CustomerName: reservationInfo?.customerName ?? '',
        CustomerPhone: reservationInfo?.customerPhone ?? '',
        Email: reservationInfo?.customerEmail ?? '',
        CountryCode: 'MX',
        ReservationDateLocalTime: datePerformance,
        OldReservationId: reservationInfo.reservationId,
        comments: specialRequest || '',
      });
      if (response?.status === 200) {
        setModifyingReservation(false);
        setResponse(true);
      }
    } catch (error) {
      switch (error.response.data.errorType) {
        case 'RESERVATION_NOT_FOUND':
          setErrorMessage(t('modifyReservationError.RESERVATION_NOT_FOUND'));
          break;
        case 'RESERVATION_NOT_ALLOWED_FOR_MODIFY':
          setErrorMessage(t('modifyReservationError.RESERVATION_NOT_ALLOWED_FOR_MODIFY'));
          break;
        case 'EXCEEDED_TIME_FOR_MODIFICATION':
          setErrorMessage(t('modifyReservationError.EXCEEDED_TIME_FOR_MODIFICATION'));
          break;
        case 'HAS_MODIFICATION':
          setErrorMessage(t('modifyReservationError.HAS_MODIFICATION'));
          break;
        case 'OLD_ORDER_ID_REQUIRED':
          setErrorMessage(t('modifyReservationError.OLD_ORDER_ID_REQUIRED'));
          break;
        case 'NO_AVAILABILITY':
          setErrorMessage(t('reservationError.NO_AVAILABILITY'));
          break;
        case 'DUPLICATE_RESERVATION':
          setErrorMessage(t('reservationError.DUPLICATE_RESERVATION'));
          break;
        default:
          setErrorMessage(t('modifyReservationError.DEFAULT'));
      }
    }
    setModifyingReservation(false);
  };

  return (
    <>
      {response ? (
        <SuccessScreen
          title={`${t('done')}!`}
          subtitle={`${t('modifyReservationSuccess')}`}
          path={'/'}
        />
      ) : (
        <>
          <Header title={<div className='text-capitalize px-3'>{t('modifyReservation')}</div>} />
          <ContentApp menu={true}>
            {!loading && compareToday !== null && selectedDate !== null ? (
              <>
                <EventHeader
                  eventImg={reservationInfo?.showLogoImageUrl}
                  eventName={reservationInfo?.showName}
                  eventDescription={reservationInfo?.showName}
                  eventDate={null}
                  paxs={''}
                />
                <div className='fw-semibold text-medium text-secondary mt-3'>
                  {t('bookingHolder')}
                </div>
                <div className='font-normal bold mt-1'>{reservationInfo.customerName}</div>
                <div className='mt-3'>
                  <CustomerSpecialRequest
                    values={{ comments: specialRequest || '' }}
                    handleChange={handleSpecialRequestChange}
                  />
                </div>
                <div
                  className='position-fixed w-100'
                  style={{
                    bottom: '0',
                    left: 0,
                    backgroundColor: '#000',
                    paddingBottom: 'env(safe-area-inset-bottom)',
                    zIndex: 2,
                  }}
                >
                  <div className='container'>
                    {renderBookSelector()}
                    <div className='row justify-content-center'>
                      <div className='col-12 col-md-7 col-lg-6'>
                        {errorMessage ? <ErrorBox title={errorMessage} /> : null}
                        <Button
                          text={
                            modifyingReservation ? (
                              <Spinner size={25} color='#000' />
                            ) : (
                              t('confirmChanges')
                            )
                          }
                          size='large'
                          className={`mt-2 mb-3 ${styles.btn}`}
                          onClick={handleModify}
                          disabled={!selectedPax || !selectedPerformance}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </ContentApp>
        </>
      )}
    </>
  );
};

export default ModifyReservation;
